import { Tween } from './Tween';
import { TweenManager } from './TweenManager';
import { removeItem } from '../utils/array-utils';

export class TweenStack {
  private readonly target: object;
  private readonly multi: boolean;
  private readonly manager: TweenManager;
  private tweens: Tween[] = [];
  private tweenTargets: object[] = [];

  constructor(target: object, multiplication: boolean, manager: TweenManager) {
    this.target = target;
    this.multi = multiplication;
    this.manager = manager;
  }

  public addTween(tween: Tween): void {
    this.tweens.push(tween);
    this.tweenTargets.push(tween.target);
    tween.onComplete.addOnce(() => this.removeTween(tween));
  }

  public removeTween(tween: Tween): void {
    if (this.tweens.includes(tween)) {
      removeItem(this.tweenTargets, tween.target);
      removeItem(this.tweens, tween);
    }
  }

  public addTarget(target: object): void {
    this.tweenTargets.push(target);
  }

  public update(): void {
    const prop: object = {};

    for (const target of this.tweenTargets) {
      Object.entries(target).forEach(([key, value]: [string, number]) => {
        if (prop[key] === undefined) {
          prop[key] = this.multi ? 1 : 0;
        }

        if (this.multi) {
          prop[key] *= value;
        } else {
          prop[key] += value;
        }
      });
    }

    Object.assign(this.target, prop);
  }

  public destroy(): void {
    this.clear();
    this.manager.removeTweenStack(this);
  }

  public clear(): void {
    this.tweens.forEach((tween: Tween) => tween.stop());
    this.tweens = [];
    this.tweenTargets = [];
  }
}
